<script>
import SnackbarContainer from './components/SnackBar/Container.vue';
import { useRTLView } from '../dashboard/composables/useRTLView';

export default {
  components: { SnackbarContainer },
  setup() {
    const { isRTLView, updateRTLDirectionView } = useRTLView();
    return { isRTLView, updateRTLDirectionView };
  },
  data() {
    return {
      theme: 'light',
    };
  },
  mounted() {
    this.setColorTheme();
    this.listenToThemeChanges();
    const locale = window.chatwootConfig.selectedLocale;
    this.setLocale(locale);
    this.updateRTLDirectionView(locale);
  },
  methods: {
    setColorTheme() {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.theme = 'dark';
        document.documentElement.classList.add('dark');
      } else {
        this.theme = 'light';
        document.documentElement.classList.remove('dark');
      }
    },
    listenToThemeChanges() {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');

      mql.onchange = e => {
        if (e.matches) {
          this.theme = 'dark';
          document.documentElement.classList.add('dark');
        } else {
          this.theme = 'light';
          document.documentElement.classList.remove('dark');
        }
      };
    },
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
    },
  },
};
</script>

<template>
  <div
    class="h-dvh min-h-dvh w-full antialiased"
    :class="[theme, { 'app-rtl--wrapper': isRTLView }]"
    :dir="isRTLView ? 'rtl' : 'ltr'"
  >
    <router-view />
    <SnackbarContainer />
  </div>
</template>

<style lang="scss">
@tailwind base;
@tailwind components;
@tailwind utilities;

@import 'shared/assets/fonts/dana';
@import '../dashboard/assets/scss/next-colors';

html,
body {
  font-family:
    'Dana',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen-Sans,
    Ubuntu,
    Cantarell,
    'Helvetica Neue',
    sans-serif;
  @apply h-full w-full;
  input,
  select {
    outline: none;
  }
}

.text-link {
  @apply text-n-brand font-medium hover:text-n-blue-10;
}

.v-popper--theme-tooltip .v-popper__inner {
  background: black !important;
  font-size: 0.75rem;
  padding: 4px 8px !important;
  border-radius: 6px;
  font-weight: 400;

  max-width: 350px;
  word-wrap: break-word;
  white-space: normal;
  text-align: justify;
  line-height: 1.6;
  unicode-bidi: plaintext;
  div {
    unicode-bidi: plaintext;
  }
}

.v-popper--theme-tooltip .v-popper__arrow-container {
  display: none;
}
</style>
